import {
  Application,
  KybDocument,
  KybDocumentStatus,
  KybDocumentType,
  KybReview,
  KybReviewStatus,
} from '__generated__/GQL';
import assertNever from 'common/bento/lib/assertNever';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getProofOfFundsStatus = ({
  company,
  isAccountHolder,
  kybDocuments,
  lastKybReview,
  legalShareCapital,
}: {
  kybDocuments: Pick<KybDocument, 'type' | 'status'>[];
  company: Pick<Application, 'isCapitalDeposit'>;
  isAccountHolder: boolean;
  lastKybReview: Pick<KybReview, 'status'> | null;
  legalShareCapital: number;
}) => {
  if (
    !company.isCapitalDeposit ||
    !isAccountHolder ||
    legalShareCapital < 5000
  ) {
    return VerificationStatus.Irrelevant;
  }

  const proofOfFundsDocument = kybDocuments.find(
    ({ type }) => type === KybDocumentType.ProofOfFunds,
  );

  if (!proofOfFundsDocument) {
    return VerificationStatus.ToDo;
  }

  switch (proofOfFundsDocument.status) {
    case KybDocumentStatus.Pending: {
      return lastKybReview?.status === KybReviewStatus.Prechecked
        ? VerificationStatus.Validated
        : VerificationStatus.Completed;
    }

    case KybDocumentStatus.Validated:
      return VerificationStatus.Validated;

    case KybDocumentStatus.Refused:
      return VerificationStatus.Invalid;

    case KybDocumentStatus.Missing:
      return VerificationStatus.ToDo;

    default:
      return assertNever(proofOfFundsDocument.status);
  }
};

export default getProofOfFundsStatus;
